<template>
  <div>
    <div class="date-wrapper">
      <span class="date-strip__month">{{ timeSession }}</span>
      <FilterChipButtons
          :isButtonActive="isButtonActive"
          :chipsList="chipsList"
          :clearFilter="clearFilter"
          @handleChipClick="handleChipClick"
          :useContentAsKey="true"
      />
    </div>
    <div v-if="filterModalIsVisible">
      <FilterModal
          :filterModalIsVisible="filterModalIsVisible"
          :currentModalFilter="currentModalFilter"
          :currentModalLabel="currentModalLabel"
          :selectedChips="selectedChips"
          :filters="filters"
          :dateError="date.error"
          :dateOption="date.option"
          :dateRange="date.selectedRange"
          @closeModal="closeModal"
          @applySelection="applySelection"
          @setItem="setItem"
      />
    </div>
    <v-skeleton-loader
        v-if="subSessionsLoading"
        v-bind="attrs"
        max-width="555"
        width="100%"
        type="list-item, list-item-three-line, card-heading"
        class="mt-3"
    />
    <div v-else>
      <div class="agenda-page__not-found" v-if="!agendaSessions.length" style="width: 100%">
        <NewsFeedEmpty
            v-if="!hasSearchText"
            title="Session is empty at the moment."
            description="Check back later."
            class="mt-5"
        />
        <span v-else class="agenda-page__not-found__text">
          No results found
        </span>
      </div>
      <div v-for="{ date, data } in agendaSessions" :key="date">
        <div v-for="(agenda, index) in data" :key="index">
          <AgendaCard :agenda-event="agenda" />
        </div>
      </div>
      <div
          class="d-flex my-9 justify-center home-page__pagination"
          v-if="agendaSessions.length > 0"
      >
        <v-pagination
            color="#F2F2F2"
            :total-visible="10"
            circle
            v-model="filters.page"
            @input="(e) => onPageChange(e)"
            :length="+this.subSessionsPageCount"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import AgendaCard from '@/components/Event/AgendaCard'
import Filter from '@/mixins/Filter'
import FilterChipButtons from '@/components/FilterChipButtons.vue'
import FilterModal from '@/components/Modals/FilterModal.vue'
import NewsFeedEmpty from '@/components/Post/NewsFeedEmpty.vue'
export default {
  name: 'SubSessionList',
  mixins: [Filter],
  components: {
    NewsFeedEmpty,
    FilterModal,
    FilterChipButtons,
    AgendaCard,
  },
  data() {
    return {
      attrs: {
        elevation: 0,
      },
    }
  },
  computed: {
    ...mapGetters('event', [
      'subSessions',
      'subSessionsLoading',
      'subSessionsError',
      'subSessionsPageCount',
      'eventTracks',
      'session'
    ]),
    ...mapGetters('app', ['search']),
    timeSession() {
      if (!this.session || !Array.isArray(this.session.sessionView)) return ''
      const infoBlock = this.session.sessionView.find(
          (item) => item.block_name === 'sessionInfo'
      )
      const data = infoBlock?.block_data
      if (!data?.events_agenda_from) return ''

      const date = new Date(data.events_agenda_from * 1000)
      const weekday = date.toLocaleString('en-US', { weekday: 'short' }).toUpperCase()
      const day = date.getDate()
      const month = date.toLocaleString('en-US', { month: 'long' }).toUpperCase()
      const year = date.getFullYear()

      return `${weekday} ${day}, ${month} ${year}`
    },

    hasSearchText() {
      return !!this.search?.trim()
    },
    agendaSessionsBlock() {
      return this.subSessions.map((subSessions) => {
        if (!subSessions || !Array.isArray(subSessions.sessionsList)) return null
        const block = subSessions.sessionsList.find((b) => b.block_name === 'sessionInfo')
        return block ? block.block_data : null
      })
    },
    agendaSessions() {
      const result = []
      this.agendaSessionsBlock.forEach((event) => {
        const fromDate = new Date(event.events_agenda_from * 1000)
        const month = fromDate.toLocaleString('en-US', { month: 'long' })
        const day = fromDate.getDate()
        const year = fromDate.getFullYear()
        const key = `${month} ${day}`
        if (result.length === 0) {
          result.push({
            date: key,
            data: [event],
          })
        } else {
          const lastGroup = result[result.length - 1]
          if (lastGroup.date === key) {
            lastGroup.data.push(event)
          } else {
            result.push({
              date: key,
              data: [event],
            })
          }
        }
      })
      return result.map(({ date, data }) => ({ date, data }))
    },
  },
  methods: {
    ...mapActions('event', ['getSubSessions', 'clearEventTracks', 'getEventTracks', 'getSession','speakerClear']),
    ...mapActions('app', ['setPageTitle']),
  },
  mounted() {
    this.setPageTitle('Sub-sessions')
  },
  beforeDestroy() {
    this.setPageTitle('')
    this.clearEventTracks()
    this.speakerClear()
  },
  created() {
    this.getSubSessions(this.requestQuery)
    this.getSession(this.$route.query.events_agenda_id)
    this.getEventTracks({ eventId: this.$route.query.event_id, page: 1 })
  },
}
</script>
